import type { Shift, ShiftResponse, ShiftListResponse } from "@/schemas";
import {
  ShiftSchemaResponse,
  ShiftListSchemaResponse,
  ShiftSearchListSchemaResponse,
} from "@/schemas";
import type { Role } from "@/utils/hooks/use-role";

import { apiRequest } from "./apiUtils";

export async function createShift(shift: Shift) {
  const data = await apiRequest<ShiftResponse>(`business/shift`, {
    method: "POST",
    body: JSON.stringify(shift),
  });
  return ShiftSchemaResponse.parse(data);
}

export async function updateShift(
  shiftId: number,
  shift: Partial<Shift> & Record<string, unknown>,
) {
  const data = await apiRequest<ShiftResponse>(`business/shift/${shiftId}`, {
    method: "PUT",
    body: JSON.stringify(shift),
  });
  return ShiftSchemaResponse.parse(data);
}

export async function getShifts(opts?: {
  page?: number;
  page_size?: number;
  startDate?: string;
  endDate?: string;
  sortOrder?: "asc" | "desc";
}) {
  const page = opts?.page ?? 0;
  const page_size = opts?.page_size ?? 50;
  const body: Record<string, unknown> = { page, page_size };
  if (opts?.startDate) body.start_date = opts.startDate;
  if (opts?.endDate) body.end_date = opts.endDate;
  if (opts?.sortOrder) body.sort_order = opts.sortOrder;
  const data = await apiRequest<ShiftListResponse>(`business/shift/list`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  return ShiftListSchemaResponse.parse(data);
}

export async function search({
  role,
  page,
  page_size,
}: {
  role: Role;
  page?: number;
  page_size?: number;
}) {
  const url =
    role === "worker"
      ? "/api/worker/shift/search"
      : "/api/business/shift/worker-search";
  const params = new URLSearchParams();
  if (page !== undefined) params.append("page", page.toString());
  if (page_size !== undefined) params.append("page_size", page_size.toString());
  const query = params.toString() ? `?${params.toString()}` : "";
  const data = await apiRequest<unknown>(`${url}${query}`, { method: "GET" });
  return ShiftSearchListSchemaResponse.parse(data);
}
